import { UploadStatus } from '@air/redux-uploader';

import { BOUNDING_BOX_LAYER_Z_INDEX } from '~/components/BoundingBox/constants';

export const INVALID_VERSION_UPLOAD_STATUS = [UploadStatus.aborted, UploadStatus.failed, UploadStatus.rejected];

export const BIG_PLAY_Z_INDEX = BOUNDING_BOX_LAYER_Z_INDEX + 1;
